// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"afc765b062537dd78a3d","678":"f9d12021670fa886639a","883":"755533bdd5213525d440"}[chunkId] + ".js";
};